import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=0c3a938b&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a938b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3a938b')) {
      api.createRecord('0c3a938b', component.options)
    } else {
      api.reload('0c3a938b', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=0c3a938b&scoped=true&", function () {
      api.rerender('0c3a938b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2asVt7o4xF28k/JS/comp/Voucher-Unit.vue"
export default component.exports